// extracted by mini-css-extract-plugin
export var aircallIframe = "_k5-3";
export var fabContainer = "_k5-5";
export var fabRinging = "_k5-6";
export var loadingOverlay = "_k5-4";
export var pulse = "_k5-7";
export var widgetContent = "_k5-2";
export var widgetPanel = "_k5-0";
export var widgetPanelExpanded = "_k5-1";